<template>
    <div>
        <label v-if="!hideAddressCheck"
               class="check-container mt-2">
            {{billingAddressHiddenText}}
            <input type="checkbox" v-model="hideAddress">
            <span class="check-checkmark"></span>
        </label>

        <transition name="fade">
            <div v-show="!hideAddress">
                <label for="line1">Address</label>
                <input type="text"
                       id="line1"
                       ref="line1"
                       fieldlabel="Address line 1"
                       class="form-control form-control-lg"
                       v-model="line1"
                       maxlength="100"
                        v-taurus-validator="'required'">
                <div name="line1"></div>


                <input type="text"
                       id="line2"
                       ref="line2"
                       fieldlabel="Address line 2"
                       class="form-control form-control-lg"
                       v-model="line2"
                       >

                <label for="town">Town</label>
                <input type="text"
                       id="town"
                       ref="town"
                       fieldlabel="Town"
                       class="form-control form-control-lg"
                       v-model="town"
                       maxlength="100"
                        v-taurus-validator="'required'">
                <div name="town"></div>


                <label for="county">County</label>
                <input type="text"
                       id="county"
                       ref="county"
                       fieldlabel="County"
                       class="form-control form-control-lg"
                       v-model="county"
                       maxlength="100"
                        v-taurus-validator="'required'">
                <div name="county"></div>


                <label for="postcode">Postcode</label>
                <input type="text"
                       id="postcode"
                       ref="postcode"
                       fieldlabel="Postcode"
                       class="form-control form-control-lg"
                       v-model="postcode"
                       maxlength="9"
                        v-taurus-validator="'required'">
                <div name="postcode"></div>

            </div>
        </transition>
        <div v-if="paymentErrMsg" class="text-danger">
            {{paymentErrMsg}}
        </div>
        <braintree-dropin containerId="braintree-dropin-container"
                            v-on:payment-method-requestable="onPaymentMethodRequestable"
                            v-on:no-payment-method-requestable="onNoPaymentMethodRequestable"
                            v-on:payment-method-request-success="onPaymentMethodRequestSuccess"
                            :clearPaymentMethod="clearPaymentMethod"
                          :createTransaction="createTransactionWithAddress"
                          :createToken="createToken"
                          :options="braintreeOptions"
                          :onCreate="onCreate"
                          :onDestroyStart="onDestroyStart"
                          :onDestroyEnd="onDestroyEnd"
                          :onError="onError"
                          :threeDSecureParams="threeDSecureParameters"
                          :hideSubmitButton="false"
                          :submitButtonText="'Use card'"
                          :submitButtonClasses="'button-small float-right'">
        </braintree-dropin>
    </div>
</template>
<script>
    import BraintreeDropIn from '@/components/braintree-dropin.vue';
    import { braintreeService } from '@/services/braintree.service.js'

    export default {
        name: 'claim-payment',
        props: {
            merchantId: {
                type: String,
                required: true
            },
            billingAddresHiddenOption: {
                type: Boolean,
                default: false
            },
            billingAddressHiddenText: {
                type: String,
                default: 'Use the address already entered'
            },
            billingAddressHidden: {
                type: Boolean,
                default: false
            },
            value: Object,
            onSuccess: Function,
            onFailure: Function,
            clearPaymentMethod: {
                type: Boolean,
                default: false
            }
        },
        components: {
            'braintree-dropin': BraintreeDropIn
        },
        data: () => {
            return {
                braintree: braintreeService,
                braintreeOptions: {
                    dataCollector: true,
                    threeDSecure: true,
                    vaultManager: false,
                    collectDeviceData: true,
                    requestThreeDSecureVerification: true,
                    locale: 'en_GB'
                },
                hideAddress: true,
                hideAddressCheck: false,
                firstname: null,
                lastname: null,
                line1: null,
                line2: null,
                town: null,
                county: null,
                postcode: null,
                paymentErrMsg: null,
                billingAddressValid: false,
                paymentMethodRequestSuccess: false,
                nonce: null
            }
        },
        methods: {
            watchAll: function(props, watcher) {
                var iterator = function(prop) {
                    this.$watch(prop, watcher);
                };
                props.forEach(iterator, this);
            },
            onChange() {
                let { line1, line2, town, county, postcode, provider } = this

                this.$emit("billing-address-change", { line1, line2, town, county, postcode });
                let test = !this.$validator.some(e => e.valid === false);
                if (test == false) {
                    let addrTest = this.addressValid()
                    if (!addrTest) {
                    this.hideAddress = false
                    this.hideAddressCheck = true
                    }
                }      
                this.billingAddressValid = test
                if (this.paymentMethodRequestSuccess == true)
                    this.$emit('can-attempt-payment', this.nonce)
                if (test == false)
                    this.$emit('can-not-attempt-payment')
                
            },
            addressValid() {
                let fields = ['line1','town','county','postcode']
                let addrTest = !this.$validator.some(e => fields.includes(e.vmod) && e.valid === false)
                return addrTest
            },
            async createToken () {
                //console.log('createToken web');
                try {
                    return await this.braintree.getToken(this.merchantId);
                } catch (err) {
                    return err;
                }
            },
            async createTransaction (payload) {
                return await this.braintree.createTransaction(payload.nonce, this.amount, this.merchantId).then((response) => {
                    try {
                        //console.log('view createTransaction Success');
                        //console.log(' r - ', response);
                        return response.transaction;
                    } catch (err) {
                        throw err;
                    }
                });
            },
            async createTransactionWithAddress(payload) {
                let request = {
                    nonce: payload.nonce,
                    amount: this.amount,
                    customerId: this.clientId,
                    billingAddress: {
                        line1: this.line1,
                        line2: this.line2,
                        city: this.town,
                        county: this.county,
                        postcode: this.postcode
                    }
                }
                return await this.braintree.createTransactionIncBillingAddress(request).then((response) => {
                    try {
                        //console.log('view createTransaction Success');
                        //console.log(' r - ', response);

                        let { transaction, paymentSuccess, errors } = response.data
                        if (paymentSuccess == true) {
                            if (this.onSuccess) {
                                this.onSuccess(transaction)
                            }
                            this.$emit('success', response.transaction)
                        } else {
                            if (this.onFailure) {
                                this.onFailure(transaction)                               
                            }
                            this.$emit('failure', transaction)
                            this.clearPaymentMethod = true
                        }
                        return response.transaction;
                    } catch (err) {
                        throw err;
                    }
                });
            },
            async onPaymentMethodRequestable() {
                //console.log('onPaymentMethodRequestable')
                //this.$emit('can-attempt-payment')
            },
            async onNoPaymentMethodRequestable() {
                this.paymentMethodRequestSuccess = false
                this.$emit('can-not-attempt-payment')
            },
            async onPaymentMethodRequestSuccess(payload) {
                this.paymentMethodRequestSuccess = true
                this.nonce = payload.nonce
                this.billingAddressValid = this.checkForm()
                if (this.billingAddressValid == true)
                    this.$emit('can-attempt-payment', this.nonce)
                else
                {
                    this.hideAddress = false
                    this.$emit('can-not-attempt-payment')
                }
            },
            async onPaymentMethodRequestError() {
                this.paymentMethodRequestSuccess = false
                this.$emit('can-not-attempt-payment')
            },
            async onCreate(instance) {
                try {
                    //console.log('onCreate');
                } catch (err) {
                    throw err;
                }
            },
            async onDestroyStart() {
                try {
                   // console.log('onDestroyStart');
                } catch (err) {
                    throw err;
                }
            },
            async onDestroyEnd () {
                try {
                    //console.log('onDestroyEnd');
                } catch (err) {
                    throw err;
                }
            },
            async onError (error) {
                try {
                    console.log('onError', error);
                } catch (err) {
                    throw err;
                }
            }
        },
        mounted() {
            this.hideAddress = this.billingAddressHidden
            this.hideAddressCheck = this.billingAddresHiddenOption
            this.line1 = this.value.line1
            this.line2 = this.value.line2 
            this.town = this.value.city
            this.county = this.value.county
            this.postcode = this.value.postcode
        
            this.watchAll(['line1', 'line2', 'town', 'county', 'postcode'], this.onChange.bind(this));
            //console.log('this.checkForm() - ', this.checkForm())
        },
        computed: {
            threeDSecureParameters() {
                return {
                            amount: this.value.amount,
                            email: null,
                            billingAddress: {
                                givenName: null,
                                surname: null,
                                phoneNumber: null,
                                
                                streetAddress: this.line1,
                                extendedAddress: this.line2,
                                locality: this.county,
                                postalCode: this.postCode,
                                countryCodeAlpha2: "GB"
                            },
                            additionalInformation: null,
                        };
            }
        }
    }
</script>
<style>
    [data-braintree-id="toggle"] {
        display: none;
    }
</style>